import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { Text } from "components/text";
import { Control, UseFormRegister, useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SignUpSchemaType } from "../utils";

interface ISBNFieldProps {
  register: UseFormRegister<SignUpSchemaType>;
  control: Control<SignUpSchemaType>;
}

export const ISBNField = ({ register, control }: ISBNFieldProps) => {
  const { t } = useTranslation(["contactUs"]);
  const { errors } = useFormState({ control, name: "isbn" });
  return (
    <div className="space-y-2">
      <Label className="text-sm">{t("contactUs:form.isbn.label")}</Label>
      <Input
        {...register("isbn", { minLength: 13, maxLength: 13 })}
        placeholder={t("contactUs:form.isbn.placeholder")}
        aria-invalid={errors.isbn ? "true" : "false"}
        className="text-sm rounded-lg h-12 border-secondary-200"
      />
      {errors.isbn && (
        <Text variant="errorSmall" className="p-0">
          {t("contactUs:form.errors.isbn")}
        </Text>
      )}
    </div>
  );
};
